import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { WeddingsPage } from './pages/WeddingsPage';
import { CellarDoorPage } from './pages/CellarDoorPage';
import { RestaurantPage } from './pages/RestaurantPage';
import { WineClubPage } from './pages/WineClubPage';
import { ContactPage } from './pages/ContactPage';
import { AboutPage } from './pages/AboutPage';
import { BlogPage } from './pages/BlogPage';
import { BlogPostPage } from './pages/BlogPostPage';
import { PinkBlushRosePage } from './pages/PinkBlushRosePage';
import { CornFrittersPage } from './pages/CornFrittersPage';
import { UniversalChapelPage } from './pages/UniversalChapelPage';
import { MembersHarvestPage } from './pages/MembersHarvestPage';
import { GelatoSparklingPage } from './pages/GelatoSparklingPage';
import { ThirtyYearsPage } from './pages/ThirtyYearsPage';
import { WineClubBenefitsPage } from './pages/WineClubBenefitsPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { RefundPolicyPage } from './pages/RefundPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
import { FreightGuidePage } from './pages/FreightGuidePage';
export function AppRouter() {
  return <BrowserRouter data-id="element-12">
      <Routes data-id="element-13">
        <Route path="/" element={<App data-id="element-15" />} data-id="element-14" />
        <Route path="/about" element={<AboutPage data-id="element-17" />} data-id="element-16" />
        <Route path="/weddings" element={<WeddingsPage data-id="element-19" />} data-id="element-18" />
        <Route path="/cellar-door" element={<CellarDoorPage data-id="element-21" />} data-id="element-20" />
        <Route path="/restaurant" element={<RestaurantPage data-id="element-23" />} data-id="element-22" />
        <Route path="/wine-club" element={<WineClubPage data-id="element-25" />} data-id="element-24" />
        <Route path="/blog" element={<BlogPage data-id="element-27" />} data-id="element-26" />
        <Route path="/blog/bubbleologist-experience" element={<BlogPostPage data-id="element-29" />} data-id="element-28" />
        <Route path="/blog/pink-blush-rose" element={<PinkBlushRosePage data-id="element-31" />} data-id="element-30" />
        <Route path="/blog/corn-fritters" element={<CornFrittersPage data-id="element-33" />} data-id="element-32" />
        <Route path="/blog/universal-chapel" element={<UniversalChapelPage data-id="element-35" />} data-id="element-34" />
        <Route path="/blog/members-harvest" element={<MembersHarvestPage data-id="element-37" />} data-id="element-36" />
        <Route path="/blog/gelato-sparkling" element={<GelatoSparklingPage data-id="element-39" />} data-id="element-38" />
        <Route path="/blog/thirty-years" element={<ThirtyYearsPage data-id="element-41" />} data-id="element-40" />
        <Route path="/blog/wine-club-benefits" element={<WineClubBenefitsPage data-id="element-43" />} data-id="element-42" />
        <Route path="/contact" element={<ContactPage data-id="element-45" />} data-id="element-44" />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-47" />} data-id="element-46" />
        <Route path="/refund-policy" element={<RefundPolicyPage data-id="element-49" />} data-id="element-48" />
        <Route path="/terms-of-service" element={<TermsOfServicePage data-id="element-51" />} data-id="element-50" />
        <Route path="/freight-guide" element={<FreightGuidePage data-id="element-53" />} data-id="element-52" />
      </Routes>
    </BrowserRouter>;
}